import e from"graphql-tag";const o=e`
    fragment CircleSeries on CircleSeriesNode {
  id
  uuid
  slug
  name
  heroImage
  heroBackgroundColor
  description
  illustration
  shortDescription
  accessType
}
    `,n=e`
    fragment CircleRsvpQuestion on CircleBaseQuestion {
  __typename
  questionText
  required
  id
  ... on CircleCheckboxQuestionNode {
    __typename
  }
  ... on CircleDropdownQuestionNode {
    options {
      ... on CircleAnswerDropdownOptionNode {
        __typename
        id
        optionText
      }
    }
  }
  ... on CircleParagraphQuestionNode {
    maxCharacters
    lines
  }
  ... on CircleRadioGroupQuestionNode {
    options {
      ... on CircleAnswerRadioOptionNode {
        __typename
        id
        optionText
      }
    }
  }
  ... on CircleSingleLineQuestionNode {
    maxCharacters
  }
}
    `,s=e`
    fragment CircleFacilitator on CircleFacilitatorNode {
  id
  photo
  name
  credential
  country
  countryCode
}
    `,r=e`
    fragment CircleTopicBase on CircleTopicNode {
  id
  languageCode
  name
  uuid
  slug
  description
  note
  format
  duration
  rsvpQuestions {
    ...CircleRsvpQuestion
  }
  facilitators {
    totalCount
    edges {
      cursor
      node {
        ...CircleFacilitator
      }
    }
  }
  series {
    id
    uuid
    name
    slug
    accessType
  }
}
    `,c=e`
    fragment CircleRsvpBase on CircleRsvpNode {
  id
  joinSessionUrl
  state
}
    `,t=e`
    fragment CircleTopicSession on CircleSessionNode {
  id
  startTime
  rsvpLink
  bookingStatus
  isJoinable
  companyUuid
  companyName
  facilitators {
    ...CircleFacilitator
  }
}
    `,a=e`
    fragment CircleTopicRsvp on CircleRsvpNode {
  ...CircleRsvpBase
  session {
    id
    ...CircleTopicSession
  }
}
    `,l=e`
    fragment CircleTopicAuthenticated on CircleTopicNode {
  ...CircleTopicBase
  activeRsvps {
    ...CircleTopicRsvp
  }
  sessions(first: 100, excludeActiveRsvps: true) {
    totalCount
    edges {
      node {
        ...CircleTopicSession
      }
    }
  }
}
    `,d=e`
    fragment CircleTopic on CircleTopicNode {
  ...CircleTopicBase
  sessions(first: 100) {
    totalCount
    edges {
      node {
        ...CircleTopicSession
      }
    }
  }
}
    `,p=e`
    fragment CircleSession on CircleSessionNode {
  id
  uuid
  startTime
  rsvpLink
  bookingStatus
  isJoinable
  companyUuid
  companyName
  facilitators {
    ...CircleFacilitator
  }
  topic {
    id
    format
    name
    slug
    duration
    languageCode
    series {
      id
      name
      slug
      accessType
    }
  }
}
    `,C=e`
    fragment CircleRsvp on CircleRsvpNode {
  ...CircleRsvpBase
  session {
    id
    ...CircleSession
  }
}
    `,u=e`
    fragment CircleOnDemand on CircleOnDemandNode {
  id
  uuid
  slug
  series {
    id
    name
    slug
    accessType
  }
  name
  description
  languageCode
  facilitators {
    ...CircleFacilitator
  }
  relatedTopics {
    id
    name
    uuid
    slug
    description
    note
    format
    duration
    facilitators {
      totalCount
      edges {
        cursor
        node {
          ...CircleFacilitator
        }
      }
    }
    series {
      id
      uuid
      name
      slug
      accessType
    }
  }
  video {
    durationInSeconds
    externalVideoUrl
    thumbnail
  }
}
    `;export{s as CircleFacilitatorFragmentDoc,u as CircleOnDemandFragmentDoc,c as CircleRsvpBaseFragmentDoc,C as CircleRsvpFragmentDoc,n as CircleRsvpQuestionFragmentDoc,o as CircleSeriesFragmentDoc,p as CircleSessionFragmentDoc,l as CircleTopicAuthenticatedFragmentDoc,r as CircleTopicBaseFragmentDoc,d as CircleTopicFragmentDoc,a as CircleTopicRsvpFragmentDoc,t as CircleTopicSessionFragmentDoc};
//# sourceMappingURL=fragments.generated.es.js.map
